const style = {
  grid: {
    flexWrap: 'nowrap',
  },
};

export default style;
